import { useQuery, useMutation } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";
// This function fetches the list of advance payments for employees based on the company code.
const getEmployeeAdvancePaymentList = async ({
  companyCode,
  fromDate = "",
  toDate = "",
  employeeCode = 0,
  locationCode = 0,
  code = 0,
  isAllCompanies = false,
  selectedCompanyCode = "",
  userId = 0,
}) => {
  let queryString = `${
    isAllCompanies
      ? Api_EndPoints.AllCompanies_GetEmployeeAdvancePaymentList
      : Api_EndPoints.GetEmployeeAdvanceList
  }?CompanyCode=${isAllCompanies ? selectedCompanyCode : companyCode}&LocationCode=${locationCode}`;

  if (fromDate !== "" && toDate !== "") {
    queryString += `&FromDate=${fromDate}&ToDate=${toDate}`;
  }

  if (employeeCode !== 0) {
    queryString += `&EmployeeCode=${employeeCode}`;
  }

  if (code !== 0) {
    queryString += `&Code=${code}`;
  }
  if (isAllCompanies && userId) {
    queryString += `&UserId=${userId}`;
  }

  const { data } = await http_payroll.get(queryString);
  return data;
};

//This function update the list of advance payments for employees based on the componay code and employee code
const putEmployeeAdvancePaymentList = async (data) => {
  const response = await http_payroll.put(
    Api_EndPoints.PutEmployeeAdvancePayment,
    data,
  );
  return response.data;
};

// This custom hook updates the list of advance payments for employees using React Query.
export const usePutEmployeeAdvancePaymentList = () => {
  return useMutation({
    mutationFn: putEmployeeAdvancePaymentList,
  });
};

// This custom hook fetches the list of advance payments for employees using React Query.
export const useEmployeeAdvancePaymentList = (input) => {
  const isAllCompanies = Boolean(input?.isAllCompanies);

  return useQuery({
    queryKey: [
      isAllCompanies
        ? Api_EndPoints.AllCompanies_GetEmployeeAdvancePaymentList
        : Api_EndPoints.GetEmployeeAdvanceList,
    ],
    queryFn: () => getEmployeeAdvancePaymentList(input),
    enabled: !!input?.companyCode,
    // staleTime: 0,
    fetchOnWindowFocus: false,
  });
};
